/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';
import GtinComponent from '~/src/components/common/GtinComponent';
import { CATEGORY_SOURCE_TYPE, INTEGRATION_TYPE } from '~/src/utils/integrationsConstants';
import { GOMBA_PRODUCT_SYNCHRONIZATION_STATUS } from '~/src/utils/gombaStatuses';
import GombaProductsApi from '~/src/services/api/GombaProductsApi';
import TableButton from '~/src/components/common/forms/Button/TableButton';
import ResultModal from '../components/ApiResultModal';
import { useContext, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import ApiResultModal from '../components/ApiResultModal';
import DisplayDate from '~/src/components/common/DisplayDate';
import MyContext from '~/src/services/context';


const logo = new URL('../../../../static/img/SVG/PopUpIcon.svg', import.meta.url);

export default function GenericProductsList(): JSX.Element {
  const url = `${API_URL}/products/generics/get`;
  const history = useHistory();
  const StatefullGrid = useMemo(() => withState(Grid, url), []);

  const brandCell = (p) => <td>{p?.dataItem?.brand?.name}</td>;

  const categoryCell = (p) => (
    <td>
      {p?.dataItem?.category?.name} -{' '}
      {
        Object.values(CATEGORY_SOURCE_TYPE).find(
          (s) => s.value === p?.dataItem?.category?.categorySourceType
        )?.label
      }
    </td>
  );

  const hsCodeCell = (p) => (
    <td>
      {p?.dataItem?.hsCode?.code}
      <br />
      {p?.dataItem?.hsCode?.nameEn}
    </td>
  );

  const productNameCell = (row) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/products/edit/${dataItem.id}`}>{dataItem.name}</Link>{' '}
        <Link to={`/products/edit/${dataItem.id}`} target="_blank">
          <img src={logo} alt="logo" />
        </Link>
      </td>
    );
  };

  const gtinsCell = ({ dataItem }) => {
    const gtinsArr = dataItem?.gtins;
    if (!Array.isArray(gtinsArr) || gtinsArr.length === 0) return <td />;
    return (
      <td>
        {gtinsArr.map((gtin, idx) => (
          <div key={idx} style={{ marginBottom: 4 }}>
            {gtin.cuGtin && (
              <GtinComponent text="CU" code={gtin.cuGtin} background="#F4F4F4" />
            )}
            {gtin.duGtin && (
              <GtinComponent text="DU" code={gtin.duGtin} background="#F4F4F4" />
            )}
            {gtin.dpGtin && (
              <GtinComponent text="DP" code={gtin.dpGtin} background="#F4F4F4" />
            )}
          </div>
        ))}
      </td>
    );
  };

  const priceCell = (p) => {
    const price = p?.dataItem?.price;
    return <td>{price != null ? price : ''}</td>;
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Products"
        titleRight="Create"
        onRightHandler={() => history.push('/products/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={() => history.goBack()}
      />

      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="name" title="Name" cell={productNameCell} />
          <GridColumn field="gtin" title="Gtins" cell={gtinsCell} />
          <GridColumn field="price" title="Price" cell={priceCell} />
          <GridColumn field="brandId" title="Brand" cell={brandCell} />
          <GridColumn field="category" title="Categories" cell={categoryCell} />
          <GridColumn field="hscode" title="HS Code" cell={hsCodeCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
